import { render, staticRenderFns } from "./ClassroomStudents.vue?vue&type=template&id=653fa0b2"
import script from "./ClassroomStudents.vue?vue&type=script&lang=js"
export * from "./ClassroomStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports